// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'f3f7bf2c9e75069ccc1ebc8bd35bc5b5e178d151';
export const BUILD_NUMBER = '262';
export const BUILD_TIMESTAMP = '2026-10-07T02:24:17.685Z';
